module.exports = __webpack_public_path__ + "img/por-do.d2be96f4.png";